import classNames from "classnames";
import AscTextInput from "../../../AscInputFields/AscTextInput/AscTextInput";

import styles from "./AscReflection.module.scss";
import { useAscAddModuleContentForm } from "../useAscAddModuleContentForm";

export interface AscReflectionProps {
  className?: string;
}

function AscReflection({ className }: AscReflectionProps) {
  const formik = useAscAddModuleContentForm();

  return (
    <div className={classNames(styles.ground, className)}>
      <div className={styles.form}>
        <div className={styles.formField}>
          <label className={styles.fieldLabel} htmlFor="titleReflection">
            Question / title
          </label>
          <AscTextInput
            className={classNames(styles.inputField, {
              [styles.errorInput]:
                formik.errors.titleReflection && formik.touched.titleReflection,
            })}
            fullWidth={true}
            placeholder="Enter title"
            id="titleReflection"
            name="titleReflection"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.titleReflection}
          />
        </div>

        <div className={styles.formField}>
          <label className={styles.fieldLabel} htmlFor="number">
            Number of answers
          </label>
          <AscTextInput
            className={classNames(styles.inputField, {
              [styles.errorInput]:
                formik.errors.number && formik.touched.number,
            })}
            fullWidth={true}
            placeholder="Number of answers"
            id="number"
            name="number"
            type="number"
            step={1}
            min={0}
            max={10}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.number}
          />
        </div>
      </div>
    </div>
  );
}

export default AscReflection;
